module.exports = __webpack_public_path__ + "57aafd5078e5c9aa3521a1b525778c4b.png";